import React from "react";
import { imgUrl } from "../../lib/api";

export const STATUS_META = {
  new: { label: "FRESHLY LOGGED", bg: "bg-magenta", text: "text-cream", ring: "border-magenta" },
  in_review: { label: "UNDER REVIEW", bg: "bg-lemon", text: "text-plum-deep", ring: "border-lemon" },
  identified: { label: "IDENTIFIED", bg: "bg-forest", text: "text-cream", ring: "border-forest" },
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-NZ", { day: "numeric", month: "short", year: "numeric" }) : "";

export const StatusStamp = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.new;
  return (
    <span
      data-testid="bloom-status-stamp"
      className={`inline-block rotate-[-6deg] border-[3px] border-cream/80 ${meta.bg} ${meta.text} rounded-lg px-3 py-1.5 font-serif-display uppercase tracking-[0.22em] text-xs font-bold shadow-lg`}
    >
      {meta.label}
    </span>
  );
};

export const CodePlate = ({ code, className = "" }) => (
  <span className={`inline-flex items-center gap-2 bg-plum-deep text-lemon rounded-lg px-4 py-2 font-mono tracking-[0.3em] text-sm font-bold shadow-[inset_0_2px_6px_rgba(0,0,0,0.5)] ${className}`} data-testid="bloom-code-plate">
    <span className="w-1.5 h-1.5 rounded-full bg-cream/30" />
    {code}
    <span className="w-1.5 h-1.5 rounded-full bg-cream/30" />
  </span>
);

export const Barcode = ({ className = "" }) => (
  <div
    aria-hidden
    className={`h-8 ${className}`}
    style={{
      backgroundImage:
        "repeating-linear-gradient(90deg, currentColor 0 2px, transparent 2px 5px, currentColor 5px 6px, transparent 6px 11px, currentColor 11px 14px, transparent 14px 17px)",
    }}
  />
);

export const EntryCard = ({ entry }) => {
  const isTeam = entry.author === "team";
  return (
    <div
      className={`relative rounded-3xl border-2 p-5 ${isTeam ? "bg-forest/10 border-forest/40" : "bg-warmwhite border-plum-deep/10"}`}
      data-testid={`bloom-entry-${entry.id}`}
    >
      <div className="flex items-center gap-3 flex-wrap">
        <span className={`text-[10px] uppercase tracking-[0.2em] font-bold rounded-full px-3 py-1 ${isTeam ? "bg-forest text-cream" : "bg-blush text-plum-deep"}`}>
          {isTeam ? "THE FOUNDRY TEAM" : "GROWER LOG"}
        </span>
        <span className="text-xs text-plum-deep/50 uppercase tracking-[0.14em]">{fmtDate(entry.created_at)}</span>
        {entry.flower_colour && <span className="text-[10px] uppercase tracking-[0.14em] bg-magenta/10 text-magenta rounded-full px-3 py-1 font-semibold">COLOUR: {entry.flower_colour}</span>}
        {entry.growth_habit && <span className="text-[10px] uppercase tracking-[0.14em] bg-plum/10 text-plum rounded-full px-3 py-1 font-semibold">HABIT: {entry.growth_habit}</span>}
      </div>
      {entry.notes && <p className="mt-3 text-sm text-plum-deep/85 whitespace-pre-wrap">{entry.notes}</p>}
      {entry.photos?.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-3">
          {entry.photos.map((p) => (
            <a key={p} href={imgUrl(p)} target="_blank" rel="noreferrer" className="block w-24 h-24 rounded-2xl overflow-hidden border-2 border-plum-deep/10 hover:border-magenta transition-colors">
              <img src={imgUrl(p)} alt="Plant progress" className="w-full h-full object-cover" loading="lazy" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
